<div class="flex justify-between items-center mb-4">
  <h2 class="text-2xl font-semibold">Titulo de empleo</h2>
  <button
    (click)="openModal('add')"
    class="bg-primary text-white px-4 py-2 rounded transform transition-transform duration-200 cursor-pointer hover:scale-105"
    [disabled]="loadingJobTitles"
  >
    Crear nuevo titulo de empleo
  </button>
</div>
<app-loading
  *ngIf="loadingJobTitles"
  text="Cargando titulos de empleo"
></app-loading>
<div class="bg-white rounded border border-gray-200" *ngIf="!loadingJobTitles">
  <app-table-generic
    [columns]="columns"
    [data]="jobTitles"
    [actions]="actions"
    [showPagination]="false"
    (edit)="openModal('edit', $event)"
  >
  </app-table-generic>
</div>
<app-modal-form
  *ngIf="mostrarModalAgregar"
  [title]="'Crear cargo'"
  [form]="formAgregar"
  [fields]="fieldsAgregar"
  [loading]="loadingAgregar"
  (formSubmit)="crearJobTitle()"
  (cancel)="mostrarModalAgregar = false"
  submitText="Crear"
>
</app-modal-form>
<app-modal-form
  *ngIf="mostrarModalEditar"
  [title]="'Editar cargo'"
  [form]="formEditar"
  [fields]="fieldsEditar"
  [loading]="loadingEditar"
  submitText="Actualizar"
  (formSubmit)="actualizarJobTitle()"
  (cancel)="mostrarModalEditar = false"
>
</app-modal-form>
